import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Connection state
  connectionStatus: 'idle', // 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error'
  error: null,
  reconnectAttempts: 0,

  // Single active subscription (Redux is source of truth)
  // subscription: {
  //   topic: null,
  //   accountNumber: null,
  //   planId: null
  // },

  subscriptions: {
    runningPositions: {
        accountNumber: null,
        planId: null
    },
    notifications: {
        subscribed: false
    }
},

  // Data state (safe defaults)
  openOrdersData: {
    orders: [],
    // balance: 0,
    // equity: 0,
    // usedMargin: 0,
    // freeMargin: 0,
    pnl: 0,
    // totalCommission: 0,
    // totalSpreadCommission: 0
  }
};

const socketSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    },
    // setSubscription: (state, action) => {
    //   const { topic, accountNumber, planId } = action.payload;
    //   state.subscription = {
    //     topic: topic || null,
    //     accountNumber: accountNumber || null,
    //     planId: planId || null
    //   };
    // },
    setRunningPositionSubscription: (state, action) => {
    state.subscriptions.runningPositions = {
        accountNumber: action.payload.accountNumber,
        planId: action.payload.planId
    };
},
    // clearSubscription: (state) => {
    //   state.subscription = {
    //     topic: null,
    //     accountNumber: null,
    //     planId: null
    //   };
    // },
    clearRunningPositionSubscription: (state) => {
    state.subscriptions.runningPositions = {
        accountNumber: null,
        planId: null
    };
},
setNotificationSubscription: (state, action) => {
    state.subscriptions.notifications.subscribed = action.payload;
},
    setOpenOrdersData: (state, action) => {
      state.openOrdersData = action.payload;
    },
    resetOpenOrdersData: (state) => {
      state.openOrdersData = {
        orders: [],
        // balance: 0,
        // equity: 0,
        // usedMargin: 0,
        // freeMargin: 0,
        pnl: 0,
        // totalCommission: 0,
        // totalSpreadCommission: 0
      };
    },
    resetSocketState: (state) => {
      return initialState;
    }
  }
});

export const {
  setConnectionStatus,
  setError,
  incrementReconnectAttempts,
  resetReconnectAttempts,
  // setSubscription,
  // clearSubscription,
  setRunningPositionSubscription,
  clearRunningPositionSubscription,
  setNotificationSubscription,
  setOpenOrdersData,
  resetOpenOrdersData,
  resetSocketState
} = socketSlice.actions;

export default socketSlice.reducer;
